// Update military pay tables for 2025
const basePayTable: { [key: string]: { [key: number]: number } } = {
  'E-5': {
    4: 3649.28,
    5: 3859.70,
    6: 4069.17,
  }
};

const bahRates: { [key: string]: { with: number, without: number } } = {
  'E-5': {
    with: 2205,
    without: 1785
  }
};

// Update BAS rates for 2025
const basRates = {
  enlisted: 452.56,
  officer: 311.68
};

// Update TSP contribution limits for 2025
const tspLimits = {
  regular: 23000,
  catchup: 7500,
  catchupAge: 50
};

export default tspLimits